export const subSymbol: unique symbol = Symbol('subscription');
export const decoratedSymbol: unique symbol = Symbol('decorated');
export const onInitSymbol: unique symbol = Symbol('onInit');
export const onDestroySymbol: unique symbol = Symbol('onDestroy');
